module.exports = __webpack_public_path__ + "common/logistics/icon-lalamove-83f7cb8bd16337c581cf4c477ad56571.svg";